import React, { useContext, useEffect } from "react";
import { Link,Switch,Route, NavLink, useHistory } from "react-router-dom";
import UserContext from "../context/users/UserContext";
import { ToastContainer, toast } from "react-toastify";
import "../css/dashboard.css";
import barSvg from "../image/bars-solid.svg";
import uiContext from "../context/ui/uiContext";
import TextEditor from "./TextEditor";
import EditBlog from "./EditBlog";
import Myaccount from "./Myaccount";


function Dashboard(props) {
  const history = useHistory();
  const context = useContext(UserContext);
  const dashContext=useContext(uiContext);

  useEffect(() => {
    props.setProgress(10);
    document.title = "Dashboard - BlogPoint";
    if (!localStorage.getItem("auth-token")) {
      return history.push("/login");
    }
    toast("Welcome Author", {
      position: "bottom-right",
    });
    props.setProgress(100);
    // eslint-disable-next-line
  }, []);

  const handleDashNavClick=()=>{
    dashContext.setDashNav(()=>{
      
      return dashContext.dashNav?0:1;
    })
  }

  return (
    <>
      <ToastContainer />
      <div className="dashboardcontainer">
        <div className={dashContext.dashNav?"dashnav":"dashnav navToggle"}>
          <ul>
            <li>
              <NavLink activeClassName="link" to="/dashboard/myaccount" exact>
                My Account
              </NavLink>
            </li>
            <li>
              <NavLink activeClassName="link" to="/dashboard/uploadblog" exact>
                Add Blog
              </NavLink>
            </li>
            <li>
              <NavLink activeClassName="link" to="/dashboard/myblog" exact>
                My Blog
              </NavLink>
            </li>
            
          </ul>
        </div>
        <div className="dashright">
          <div className="dashburger">
            <img onClick={handleDashNavClick} src={barSvg} alt="burger nav"/>
          </div>
          <div className="rightcontent">
            <Switch>
            <Route path="/dashboard/myaccount">
                <Myaccount/>
              </Route>
              <Route path="/dashboard/uploadblog">
                <TextEditor/>
              </Route>
              <Route path="/dashboard/myblog">
                <EditBlog/>
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
